(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NswsUserDetailsDialogController', NswsUserDetailsDialogController);

    NswsUserDetailsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NswsUserDetails'];

    function NswsUserDetailsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NswsUserDetails) {
        var vm = this;

        vm.nswsUserDetails = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.nswsUserDetails.id !== null) {
                NswsUserDetails.update(vm.nswsUserDetails, onSaveSuccess, onSaveError);
            } else {
                NswsUserDetails.save(vm.nswsUserDetails, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:nswsUserDetailsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
